/* eslint-disable react/jsx-handler-names */
/* eslint-disable max-lines */
/* eslint-disable react/boolean-prop-naming */
"use client";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { MapPinIcon, XCircleIcon } from "@phosphor-icons/react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  INTERNATIONAL_PF_COOKIE,
  LAST_VISITED_COUNTRIES,
  LAST_VISITED_INTERNATIONAL_CITY,
  LAST_VISITED_INTERNATIONAL_LOCATION,
  SELECTED_INTERNATIONAL_CITY,
} from "../../../constants/storage";
import {
  LOCATION_CITY_SUGGESTION,
  SINGAPORE_REDIRECTION_TEXT,
  FROM_LOCATION_LOCK,
} from "../../../constants/common/locationFieldConstants";
import {
  setIsShowDesktopLocationLockAction,
  setIsShowMobileLocationLockAction,
  setIsShowMobileLocationLockDrawerAction,
  setMandateErrorAction,
  setSelectedIntLocation,
} from "../../../store/slices/locationLock";
import { formatClassNames, isJsonString, pageName, removeHashtagFromURL } from "../../../utils/common";
import { getFilteredCitiesList, getGateAutoTriggerFlag } from "../../../utils/locationLock";
import { getCleverTapPageType } from "../../../utils/fnpPageType";
import CookieUtil from "../../../utils/storage/cookieUtil";
import CustomImage from "../../atoms/customImage";
import TextField from "../../atoms/textField";
import ListDropDown from "../listDropDown";
import ButtonComponent from "../../atoms/button";
import { CONFIRM, COUNTRIES_URL } from "../../../constants/common/common";
import { cleverTapCommonEvents } from "../../../analytics/clevertapConstants";
import useAnalytics from "../../../analytics/useAnalytics";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import Portal from "../Portal";
import isEmpty from "lodash.isempty";
import { unlockBody } from "../../../utils/document";
import { setPincodeErrorFromAddToCart, setSelectedDateFromAddToCart } from "../../../store/slices/pdpSlice";
import { GA4_EVENTS } from "../../../analytics/gaConstant";
import {
  resetGetDeliveryDateAndGeoPriceAction,
  resetMultiProductDateRange,
  requestResetShippingDateAndSlot,
  setDeliveryDetailsAction,
  successToFetchBlockedDatesAction,
} from "../../../store/slices/common/shippingDateAndSlotSelection";
import BlankSpaceUI from "../blankSpaceUI";
import { resetPdpAddOnState } from "../../../store/slices/pdpAddonSlice";
import CountryChangeInfoMobile from "../countryChangeInfoMobile";
import { constants } from "../../../constants/pageConstants/pdpConstants";

/**
 * InternationalCitySuggestion component provides an input field for city suggestions.
 * It fetches and displays suggestions based on user input and manages the selected city state.
 */
const InternationalCitySuggestion = ({
  setSuggestionSelected,
  isSuggestionSelected,
  searchValue,
  setSearchValue,
  onHandleContinueShopping,
  isFromPDP,
  isFromCheckout,
  showDeliveryCityList,
  isError,
  messageText = "",
  isDisable,
  onPincodeLocationClickHandler,
  urlIdentifier,
  cleverTapPDPCommonData,
  isContinueButtonHidden = false,
  onClearSavedAddressSelection,
  selectedCountryId = "",
  serviceabilityErrorMessage,
  isCountryChanged = false,
  selectedCountry = {},
  isProductUnavailable = false,
  onExploreAvailableProducts,
  onSuggestionsVisibilityChange,
  isFromOutsideDrawer = false,
  isFromGiftFinderGate = false,
  locationCaptureMode,
  onCaptureLocation,
}) => {
  const dispatch = useDispatch();
  const { trackEvent } = useAnalytics();
  const router = useRouter();
  const pathname = usePathname();
  const [selectedRow, setSelectedRow] = useState(0);
  const lastVisitedCountries = CookieUtil.getCookie("lastVisitedCountries");

  const [timeoutId, setTimeoutId] = useState(null);
  const [cityList, setCityList] = useState([]);
  const [eventTriggered, setEventTriggered] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState({});
  /** Gift finder gate only: in-flight confirm, so the button can show progress. */
  const [isMandatoryError, setIsMandatoryError] = useState(false);
  const options = { maxAge: 60 * 60 * 24 * 7, path: "/", encode: decodeURIComponent };
  const [isErrorMsgAnimate, setIsErrorMsgAnimate] = useState(false);

  useEffect(() => {
    onSuggestionsVisibilityChange?.(cityList?.length > 0);
  }, [cityList, onSuggestionsVisibilityChange]);

  const {
    cityListDataPDP,
    cityListData,
    visitedCountry,
    isMobile,
    configData,
    isShowMobileLocationLockDrawer,
    isShowMobileLocationLock,
    savedAddresses,
    onFocusChangeFromTextfield,
    mandateErrorClick,
    selectedIntLocation,
    shouldClearLocationLockInput,
    isLoggedIn,
  } = useSelector(
    (state) => ({
      cityListDataPDP: state.locationLock.cityListDataPDP,
      cityListData: state.locationLock.cityListData,
      visitedCountry: state.locationLock.visitedCountry,
      isMobile: state.appConfig.isMobile,
      configData: state?.locationLock?.configData,
      isShowMobileLocationLockDrawer: state?.locationLock?.isShowMobileLocationLockDrawer,
      isShowMobileLocationLock: state?.locationLock?.isShowMobileLocationLock,
      savedAddresses: state?.savedAddress?.savedAddresses || [],
      onFocusChangeFromTextfield: state.locationLock.onFocusChangeFromTextfield,
      mandateErrorClick: state?.locationLock?.mandateErrorClick,
      selectedIntLocation: state?.locationLock?.selectedIntLocation,
      shouldClearLocationLockInput: state?.locationLock?.shouldClearLocationLockInput,
      isLoggedIn: state?.fus?.loginDetail?.loggedin,
    }),
    shallowEqual,
  );
  const {
    isAutoGateEnabledOnDesktopHome,
    isAutoGateEnabledOnMobileHome,
    isAutoGateEnabledOnDesktopPLP,
    isAutoGateEnabledOnMobilePLP,
    mandateGatePLPList,
  } = configData;
  const isHome = pathname === "/";
  const isPLP = pathname?.includes("-lp");
  const isCheckout = isFromCheckout || pathname?.includes("/checkout");
  const isAutoTriggerLock = getGateAutoTriggerFlag(mandateGatePLPList);
  const isAutoForDesktop =
    !isAutoTriggerLock && ((isAutoGateEnabledOnDesktopHome && isHome) || (isAutoGateEnabledOnDesktopPLP && isPLP));
  const isAutoForMobile =
    !isAutoTriggerLock && ((isAutoGateEnabledOnMobileHome && isHome) || (isAutoGateEnabledOnMobilePLP && isPLP));
  const isVisibleLocationMobileDrawer = isShowMobileLocationLockDrawer && !isShowMobileLocationLock;

  const isAutoFocus = isVisibleLocationMobileDrawer
    ? false
    : isEmpty(savedAddresses)
      ? onFocusChangeFromTextfield
      : false;

  const commonPageData = {
    page_name: pageName(isHome, isPLP, pathname, urlIdentifier),
    pageType: (typeof window !== "undefined" && window.fnpPageType) || "",
    mandatory: false,
    auto: isAutoTriggerLock ? false : isMobile ? isAutoForMobile : isAutoForDesktop,
    user_initiated: isAutoTriggerLock ? true : isMobile ? !isAutoForMobile : !isAutoForDesktop,
  };
  const ishomePlpPdpLocationData = isHome || isPLP ? commonPageData : cleverTapPDPCommonData;
  useEffect(() => {
    if (mandateErrorClick) {
      setIsErrorMsgAnimate(true);
      setTimeout(() => {
        setIsErrorMsgAnimate(false);
        dispatch(setMandateErrorAction(false));
      }, 500);
    }
  }, [mandateErrorClick, dispatch]);

  useEffect(() => {
    setSelectedLocation({});
    setSelectedRow(0);
  }, [selectedCountryId]);

  /**
   * Clears city value from the reducer and cookie.
   * Cookies are written with path `/` on select — delete must use the same path,
   * or location-lock sync will restore the city from leftover cookies.
   */
  const clearCity = () => {
    dispatch(setSelectedIntLocation({}));

    if (lastVisitedCountries && isJsonString(lastVisitedCountries)) {
      const countriesInCookie = JSON.parse(lastVisitedCountries);
      const data = {
        ...countriesInCookie,
        [visitedCountry?.countryId]: { ...countriesInCookie[visitedCountry?.countryId], city: "", cityId: "" },
      };
      CookieUtil.setCookie(LAST_VISITED_COUNTRIES, JSON.stringify(data), options);
    }

    // Always clear international location cookies (same path used when saving).
    CookieUtil.deleteCookie(INTERNATIONAL_PF_COOKIE, options);
    CookieUtil.deleteCookie(SELECTED_INTERNATIONAL_CITY, options);
    CookieUtil.deleteCookie(LAST_VISITED_INTERNATIONAL_LOCATION, options);
    CookieUtil.deleteCookie(LAST_VISITED_INTERNATIONAL_CITY, options);

    // Also clear legacy PDP-scoped cookies if present.
    const catalogIdForPath = visitedCountry?.catalogID || visitedCountry?.catelogID;
    if (catalogIdForPath) {
      const legacyPathOptions = { path: `/${catalogIdForPath}/gift` };
      CookieUtil.deleteCookie(SELECTED_INTERNATIONAL_CITY, legacyPathOptions);
      CookieUtil.deleteCookie(LAST_VISITED_INTERNATIONAL_LOCATION, legacyPathOptions);
      CookieUtil.deleteCookie(LAST_VISITED_INTERNATIONAL_CITY, legacyPathOptions);
    }
  };

  useEffect(() => {
    if (!shouldClearLocationLockInput) {
      return;
    }
    setSelectedLocation({});
    setCityList([]);
    setSearchValue("");
    setSuggestionSelected(false);
    dispatch(setDeliveryDetailsAction({}));
    dispatch(resetMultiProductDateRange());
    dispatch(successToFetchBlockedDatesAction({}));
    dispatch(requestResetShippingDateAndSlot());
    dispatch(resetGetDeliveryDateAndGeoPriceAction());
    dispatch(resetPdpAddOnState());
    dispatch(setSelectedDateFromAddToCart(""));
    dispatch(setPincodeErrorFromAddToCart(false));
    clearCity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldClearLocationLockInput, dispatch]);

  /**
   * Clears saved address selection when user manually enters pincode or city.
   */
  const clearSavedAddressSelection = () => {
    if (isContinueButtonHidden && typeof onClearSavedAddressSelection === "function") {
      onClearSavedAddressSelection();
    }
  };

  /**
   * Resolves location details from selected city or typed input for continue flow.
   * @returns {Object}
   */
  const getLocationDetailsForContinue = () => {
    if (!isEmpty(selectedLocation)) {
      return selectedLocation;
    }

    const trimmedSearchValue = searchValue?.trim();
    if (!trimmedSearchValue) {
      return {};
    }

    const cityNameKey = isFromPDP ? "CITY_NAME" : "cityName";
    const cityIdKey = isFromPDP ? "CITY_KEY" : "cityId";
    const list = isFromPDP ? cityListDataPDP : cityListData;

    const directMatch = list?.find((city) => city?.[cityNameKey]?.toLowerCase() === trimmedSearchValue.toLowerCase());
    if (directMatch) {
      return { pincode: directMatch[cityIdKey], location: directMatch[cityNameKey] };
    }

    const matches = getFilteredCitiesList(trimmedSearchValue, list, cityNameKey);
    const exactMatch = matches.find((city) => city?.[cityNameKey]?.toLowerCase() === trimmedSearchValue.toLowerCase());

    if (exactMatch) {
      return { pincode: exactMatch[cityIdKey], location: exactMatch[cityNameKey] };
    }

    if (matches.length === 1) {
      return { pincode: matches[0][cityIdKey], location: matches[0][cityNameKey] };
    }

    if (cityList.length === 1) {
      return { pincode: cityList[0][cityIdKey], location: cityList[0][cityNameKey] };
    }

    const exactListMatch = cityList.find(
      (city) => city?.[cityNameKey]?.toLowerCase() === trimmedSearchValue.toLowerCase(),
    );
    if (exactListMatch) {
      return { pincode: exactListMatch[cityIdKey], location: exactListMatch[cityNameKey] };
    }

    return {};
  };

  /**
   * Restores the previously confirmed international city in the input (and local selection).
   * Used when clear-cart is cancelled so the pending city is not kept.
   * @returns {void}
   */
  const restorePreviousInternationalCity = () => {
    const previousLocation =
      selectedIntLocation?.location || CookieUtil.getCookie(LAST_VISITED_INTERNATIONAL_LOCATION) || "";
    const previousPincode = selectedIntLocation?.pincode || CookieUtil.getCookie(LAST_VISITED_INTERNATIONAL_CITY) || "";

    setSearchValue(previousLocation);
    setSuggestionSelected(Boolean(previousLocation));
    setSelectedLocation(previousLocation ? { pincode: previousPincode, location: previousLocation } : {});
    setCityList([]);
  };

  /**
   * Continue Shopping Handler.
   */
  const onContinueClick = async (selectedLocationDetails) => {
    const locationDetails = !isEmpty(selectedLocationDetails)
      ? selectedLocationDetails
      : getLocationDetailsForContinue();

    removeHashtagFromURL(FROM_LOCATION_LOCK);

    if (!showDeliveryCityList && selectedCountryId === COUNTRIES_URL.SINGAPORE.key) {
      router.push(COUNTRIES_URL.SINGAPORE.url);
      return;
    }

    if (isEmpty(locationDetails)) {
      if (isCheckout) {
        setIsMandatoryError(true);
        return;
      }
      CookieUtil.deleteCookie(INTERNATIONAL_PF_COOKIE, options);
      CookieUtil.deleteCookie(LAST_VISITED_INTERNATIONAL_LOCATION, options);
      CookieUtil.deleteCookie(LAST_VISITED_INTERNATIONAL_CITY, options);
      dispatch(setSelectedIntLocation({}));
    }

    // Apply city/cookies only after continue succeeds — not while clear-cart is pending.
    if (onHandleContinueShopping !== undefined) {
      const shouldProceed = await onHandleContinueShopping(locationDetails);
      if (shouldProceed === false) {
        restorePreviousInternationalCity();
        return;
      }
    } else if (!isEmpty(locationDetails) && !isFromCheckout) {
      dispatch(setSelectedIntLocation(locationDetails));
    }

    if (!isFromCheckout) {
      if (isMobile) {
        dispatch(setIsShowMobileLocationLockAction(false));
        dispatch(setIsShowMobileLocationLockDrawerAction(false));
      } else {
        dispatch(setIsShowDesktopLocationLockAction(false));
      }
      // Mobile PDP drawers (standalone + pre-checkout stitch) release scroll lock on close.
      if (!(isFromPDP && isMobile)) {
        unlockBody();
      }
    }
  };

  /**
   * Confirm click.
   *
   * In capture mode this records the answer and nothing else — no cookies, no redux, no
   * navigation — because the caller applies the location later, at its own hand-off. The
   * city is optional there: confirming with only a country selected answers the step with
   * that country and an empty city, which the gate reads as "anywhere in this country".
   *
   * @returns {void}
   */
  const onConfirmClick = () => {
    const locationDetails = getLocationDetailsForContinue();

    if (locationCaptureMode) {
      onCaptureLocation?.(locationDetails);
      return;
    }

    onContinueClick(locationDetails);
  };

  /**
   * Handles the change event of the city input field.
   *
   * @param {object} e - The event object.
   */
  const onHandleCityChange = (e) => {
    dispatch(setPincodeErrorFromAddToCart(false));
    const { value } = e.target;

    if (value) {
      clearSavedAddressSelection();
    }
    if (isSuggestionSelected && value !== searchValue) {
      setSuggestionSelected(false);
      setSelectedLocation({});
    }

    setSearchValue(value);
    clearTimeout(timeoutId);
    setIsMandatoryError(false);

    if (value) {
      let timeoutRef = null;
      timeoutRef = setTimeout(() => {
        setCityList(getFilteredCitiesList(value, cityListData, "cityName"));
      }, 500);

      setTimeoutId(timeoutRef);
    } else if (value === "") {
      setCityList([]);
    } else {
      clearCity();
    }
  };

  /**
   * Handles the selection of a city from the dropdown.
   *
   * @param {object} value - The selected city object.
   */
  const onHandleSelectCity = async (value) => {
    const cityName = "cityName";
    const cityId = "cityId";

    clearSavedAddressSelection();

    setSearchValue(value?.[cityName]);
    setSuggestionSelected(true);
    setSelectedLocation({ pincode: value?.[cityId], location: value?.[cityName] });
    setCityList([]);

    // Capturing: the state set above is the whole job — picking a city only fills the
    // field, and Confirm is what answers the step, so the user can still change country
    // afterwards. Nothing is committed, so there is no clear-cart to await or veto.
    if (!locationCaptureMode) {
      const shouldProceed = await onHandleContinueShopping({
        pincode: value?.[cityId],
        location: value?.[cityName],
      });
      if (shouldProceed === false) {
        restorePreviousInternationalCity();
        return;
      }
    }

    const pageLocationCityData = { ...ishomePlpPdpLocationData, country: value?.countryId, city: value?.[cityName] };
    trackEvent(cleverTapCommonEvents.locationCitySelected, pageLocationCityData, ["clevertap"]);
    trackEvent(GA4_EVENTS.AFTER_CITY_SELECTION, { city: value?.CITY_NAME, country: visitedCountry?.catelogID }, [
      "ga4",
    ]);
  };

  /**
   * Clears the city suggestion input and resets the state.
   */
  const onHandleClearCitySuggestion = (e) => {
    e.stopPropagation();
    if (eventTriggered) return;
    setEventTriggered(true);
    const removedLocation = searchValue;
    clearSavedAddressSelection();
    setCityList([]);
    setSearchValue("");
    setSuggestionSelected(false);
    setSelectedRow(0);
    setSelectedLocation({});
    // Clear cookies before clearing Redux so location-lock sync cannot restore from cookies.
    clearCity();
    dispatch(setDeliveryDetailsAction({}));
    dispatch(resetGetDeliveryDateAndGeoPriceAction());
    dispatch(successToFetchBlockedDatesAction({}));
    const { pageType, ...restLocationData } = ishomePlpPdpLocationData || {};
    const pageRemovedData = {
      ...restLocationData,
      page_type: getCleverTapPageType(pageType || restLocationData?.page_type),
      country: visitedCountry?.countryId,
      removed_location: removedLocation,
      flow: "new",
    };
    trackEvent(cleverTapCommonEvents.locationRemoved, pageRemovedData, ["clevertap"]);

    setTimeout(() => {
      setEventTriggered(false);
    }, 500);
  };
  /**
   * @function scrollToHighlightedItem Scrolls the highlighted item into view
   * @param {object} e event object
   */
  const scrollToHighlightedItem = (e) => {
    let highlightedItem;
    if (e.key === "ArrowUp") {
      highlightedItem = document.getElementById(`list-item-${selectedRow - 1}`);
    } else if (e.key === "ArrowDown") {
      highlightedItem = document.getElementById(`list-item-${selectedRow + 1}`);
    }
    if (highlightedItem) {
      highlightedItem.scrollIntoView({ behavior: "instant", block: "nearest" });
    }
  };
  /**
   * This function is used for keyboard Up/Down and Enter keys for navigating through Location/Pincode field.
   *
   * @param {event} event object for getting keyboard keys.
   * @returns {void}
   */
  const onHandleKeyDown = (event) => {
    if (event.key === "ArrowUp") {
      if (selectedRow <= 0) {
        setSelectedRow(cityList?.length - 1);
      } else {
        setSelectedRow((prevPin) => prevPin - 1);
        scrollToHighlightedItem(event);
      }
    } else if (event.key === "ArrowDown") {
      if (selectedRow >= cityList?.length - 1) {
        setSelectedRow(0);
      } else {
        setSelectedRow((prevPin) => prevPin + 1);
        scrollToHighlightedItem(event);
      }
    } else if (event.key === "Enter" && selectedRow >= 0) {
      setSelectedRow(0);
      onHandleSelectCity(cityList[selectedRow]);
      setCityList([]);
      setSuggestionSelected(true);
    } else if (event.key === "Backspace") {
      if (cityList?.length === 0) {
        setSelectedRow(0);
      }
    }
  };
  /** onHandleFocus handles*/
  const onHandleFocus = () => {
    setIsMandatoryError(false);
    dispatch(setPincodeErrorFromAddToCart(false));
  };

  // Capture mode keeps its Confirm button: a country on its own is a valid answer for the
  // gift-finder gate ("anywhere in this country"), and selecting one clears the city field,
  // so without the button there was nothing left to press — the step stranded the user the
  // moment they switched country without picking a city.
  const shouldShowContinueButton = !isContinueButtonHidden;
  const hasLocationInput = Boolean(searchValue?.trim());
  const showProductUnavailableUi = isProductUnavailable && hasLocationInput;
  const isContinueButtonDisabled =
    !isCountryChanged &&
    (Boolean(serviceabilityErrorMessage) ||
      showProductUnavailableUi ||
      // The gate accepts a country on its own — city is optional there, so an empty
      // selection must not block Confirm. Real errors above still do.
      (!isFromGiftFinderGate && !isSuggestionSelected && isEmpty(selectedLocation)));

  /**
   * Closes the drawer and redirects via BuyNow Explore CTA handler.
   * @returns {void}
   */
  const onExploreAvailableProductsClick = () => {
    onExploreAvailableProducts?.();
  };

  return (
    <>
      {showDeliveryCityList ? (
        <>
          <TextField
            placeholder={LOCATION_CITY_SUGGESTION}
            type="text"
            id="city-suggestion-input"
            isRequired={false}
            variant="primary"
            inputValue={searchValue}
            onChange={!isDisable ? onHandleCityChange : null}
            onKeyDown={onHandleKeyDown}
            onFocus={onHandleFocus}
            isError={isMandatoryError || isError || showProductUnavailableUi}
            message={isMandatoryError || isError || hasLocationInput ? messageText : ""}
            startAdornment={isSuggestionSelected && <MapPinIcon size={24} />}
            endAdornment={
              isSuggestionSelected && (
                <XCircleIcon size={28} weight="fill" color="#d4d4d4" onClick={onHandleClearCitySuggestion} />
              )
            }
            autoFocus={isAutoFocus}
            readOnly={isSuggestionSelected}
            onClick={isDisable ? onPincodeLocationClickHandler : null}
            isErrorMsgAnimate={isErrorMsgAnimate}
          />
          {showProductUnavailableUi && isFromPDP && !isFromCheckout && onExploreAvailableProducts ? (
            <div className="mt-12">
              <ButtonComponent
                size="medium"
                buttonVariant="outlined"
                label={constants.SHOW_SIMILAR}
                id="explore-available-products-intl-button"
                onClick={onExploreAvailableProductsClick}
                classes="w-full"
                btnParentClasses="w-full"
                aria-label={constants.SHOW_SIMILAR}
              />
            </div>
          ) : null}

          {cityList?.length > 0 && (
            <ListDropDown
              id={`city-list-item`}
              suggestions={cityList}
              keyname="location-list"
              onClick={onHandleSelectCity}
              classes="overflow-auto scrollbar-thin scrollbar-webkit max-h-[36vh]"
              startAdornment={(props) => (
                <CustomImage src="/icons/location-Icon.svg" sizes="100vw" alt="location_pin" {...props} />
              )}
              listValue="cityName"
              isKeyDownSelectedRow={selectedRow}
            />
          )}
        </>
      ) : (
        <div className="flex gap-4 rounded-8 bg-blue-200/[.06] p-4 text-xs font-400 text-grey-500">
          <span className="w-16">
            <CustomImage
              src="/icons/info-circle-gray.svg"
              width={16}
              height={16}
              alt=""
              sizes="10vw"
              isPriority={false}
            />
          </span>
          <p className="w-full">
            <span className="inline-block pr-4">{SINGAPORE_REDIRECTION_TEXT}</span>
            <Link href={COUNTRIES_URL.SINGAPORE.url} className="text-blue-100">
              {COUNTRIES_URL.SINGAPORE.text}
            </Link>
          </p>
        </div>
      )}
      {shouldShowContinueButton ? (
        // Inline in the gate on both breakpoints: the mobile branch portals into roots that
        // only exist inside the location-lock overlay, so inside the quiz card the portal
        // has no target and the button never appears.
        (!isMobile && !isFromPDP && !isFromCheckout) || isFromGiftFinderGate ? (
          <div className="pt-16">
            <ButtonComponent
              size="medium"
              buttonVariant="filled"
              label={CONFIRM}
              id="location-lock-continue-button"
              onClick={onConfirmClick}
              backGroundColor={isContinueButtonDisabled ? "bg-grey-200" : "bg-fnp-300"}
              btnParentClasses={formatClassNames(isContinueButtonDisabled && "opacity-50")}
              isDisabled={isContinueButtonDisabled}
            />
          </div>
        ) : (
          <>
            {/* The gift finder gate lets the user pick country and city together as one
                answer, so a country change is expected rather than something to warn
                about — and the banner would push the fields down mid-question. */}
            {isCountryChanged && !isFromGiftFinderGate && (
              <CountryChangeInfoMobile
                countryName={selectedCountry?.countryName}
                isFromOutsideDrawer={isFromOutsideDrawer}
              />
            )}
            <Portal
              rootId={
                isVisibleLocationMobileDrawer
                  ? "locationLockWrapper"
                  : isFromCheckout && isMobile
                    ? "mobileLocationLockDA"
                    : isFromPDP
                      ? "mobileLocationLockPDP"
                      : "mobileLocationLock"
              }
              renderOnDidMount={true}
            >
              {/** this section visible on intl */}
              {!isVisibleLocationMobileDrawer && !isLoggedIn && !isFromGiftFinderGate && (
                <BlankSpaceUI
                  classes={!isFromCheckout && isMobile ? "absolute bottom-[84px]" : "absolute bottom-[136px]"}
                />
              )}
              <div
                className={formatClassNames(
                  "w-full",
                  // In the gate this portals into the question card, which has no fixed
                  // footer to pin against — absolute would drop the button on top of the
                  // city field, so it flows below it instead.
                  isFromGiftFinderGate ? "mt-12" : "bg-white-900",
                  !isVisibleLocationMobileDrawer && !isFromGiftFinderGate && "absolute bottom-0 p-16",
                  isFromCheckout && "mt-auto",
                )}
              >
                <ButtonComponent
                  size="medium"
                  buttonVariant="filled"
                  label={CONFIRM}
                  id="location-lock-continue-button"
                  onClick={onConfirmClick}
                  backGroundColor={isContinueButtonDisabled ? "bg-grey-200" : "bg-fnp-300"}
                  btnParentClasses={formatClassNames(
                    isFromCheckout && !isMobile ? "border-t-1 border-thinLightGrey p-16" : "",
                  )}
                  isDisabled={isContinueButtonDisabled}
                />
              </div>
            </Portal>
          </>
        )
      ) : (
        <></>
      )}
    </>
  );
};

export default InternationalCitySuggestion;

InternationalCitySuggestion.propTypes = {
  onHandleContinueShopping: PropTypes.func.isRequired,
  isFromPDP: PropTypes.bool,
  isFromCheckout: PropTypes.bool,
  isSuggestionSelected: PropTypes.bool,
  setSuggestionSelected: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  setSearchValue: PropTypes.func.isRequired,
  showDeliveryCityList: PropTypes.bool,
  isError: PropTypes.bool,
  messageText: PropTypes.string,
  isDisable: PropTypes.bool,
  onPincodeLocationClickHandler: PropTypes.func,
  urlIdentifier: PropTypes.string,
  cleverTapPDPCommonData: PropTypes.object,
  isContinueButtonHidden: PropTypes.bool,
  onClearSavedAddressSelection: PropTypes.func,
  selectedCountryId: PropTypes.string,
  serviceabilityErrorMessage: PropTypes.string,
  isCountryChanged: PropTypes.bool,
  selectedCountry: PropTypes.object,
  isProductUnavailable: PropTypes.bool,
  onExploreAvailableProducts: PropTypes.func,
  onSuggestionsVisibilityChange: PropTypes.func,
  isFromOutsideDrawer: PropTypes.bool,
  isFromGiftFinderGate: PropTypes.bool,
  locationCaptureMode: PropTypes.shape({ onCapture: PropTypes.func.isRequired }),
  onCaptureLocation: PropTypes.func,
};
